import { FC } from "react";

import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface AccountDispositionStatusPillPropsI extends PropsWithClassNameI {
  style?: string;
  label: string;
}

export const AccountDispositionStatusSmallPill: FC<
  AccountDispositionStatusPillPropsI
> = ({ style, label, className }) => {
  if (!label) {
    return null;
  }

  return (
    <div
      className={clsxMerge(
        "w-max min-w-[84px] px-2 py-0",
        "rounded text-center text-white typography-header-8-semibold",
        style,
        className
      )}
    >
      {label}
    </div>
  );
};
